<template>
  <div class>
    <h3 class>Detalles del pago</h3>
    <hr />
    <div class="list-group">
      <div class="row">
        <div class="col-12">
          <div class="shadow-sm rounded p-3 px-5 bg-grey">
            <div class="row" v-for="item in $parent.cartItems" :key="item._id">
              <div class="col-8">
                <p>
                  <b>{{ item.name }} </b>
                  <span class="text-secondary ml-1"
                    >({{ item.amountInCart }}
                    {{ item.kind == "service" ? "servicio" : "producto"
                    }}{{ item.amountInCart == 1 ? "" : "s" }})
                  </span>
                </p>
              </div>
              <div class="col-4 text-right">
                <p>
                  <b
                    >SC${{
                      (
                        productSCPrice(item.price, item.currency) *
                        item.amountInCart
                      ).toFixed(2)
                    }}</b
                  >
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Envío</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>SC${{ shippingPriceSC.toFixed(2) }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Descuento</b>
                </p>
              </div>
              <div class="col-6 text-right text-success">
                <p>
                  <b>-SC${{ discount }}</b>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Total</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b
                    >SC${{
                      (+this.$parent.totalCart + shippingPriceSC).toFixed(2)
                    }}</b
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!shippingPrice && !isOnlyServices" class="col-12 pt-4">
          <div
            class="alert alert-success shadow-sm text-center mb-0"
            role="alert"
          >
            Envío a domicilio!
          </div>
        </div>
        <div class="col-6 pt-4" v-show="shippingType != 2">
          <div class="shadow-sm rounded p-3 px-5 bg-grey">
            <div class="row" v-for="item in infoShipping" :key="item.nane">
              <div class="col-6">
                <p>
                  <b>{{ item.name }}:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ item.value }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 pt-4" v-show="shippingType == 2">
          <div class="shadow-sm rounded p-3 px-5 bg-grey">
            <h5>Datos de retiro de la compra:</h5>
            <div class="row mt-5">
              <div class="col-6">
                <p><b>Dirección:</b></p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ $parent.cartItems[0].pickUp.address }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p><b>Teléfono:</b></p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ $parent.cartItems[0].pickUp.phone }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p><b>Horario disponible:</b></p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ $parent.cartItems[0].pickUp.date }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 pt-4">
          <div
            class="shadow-sm rounded p-3 px-5 bg-light-red text-center"
            v-if="!canBuy"
          >
            <h5>No posee saldo suficiente para realizar esta compra</h5>
            <hr />
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Sacoin:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>SC${{ sacoin.toFixed(2) }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Financiamiento:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>SC${{ financiamiento.toFixed(2) }}</b>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Saldo faltante:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b
                    >SC${{
                      (
                        +this.$parent.totalCart +
                        shippingPriceSC -
                        (sacoin + financiamiento)
                      ).toFixed(2)
                    }}</b
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="shadow-sm rounded p-3 px-5 bg-light-blue" v-if="canBuy">
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Sacoin:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>SC${{ sacoin.toFixed(2) }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Financiamiento:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>SC${{ financiamiento.toFixed(2) }}</b>
                </p>
              </div>
            </div>
          </div>

          <div class="shadow-sm rounded p-3 px-5 bg-grey mt-4">
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Nombre:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ user.fullName }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>DNI:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ user.dni }}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>
                  <b>Email:</b>
                </p>
              </div>
              <div class="col-6 text-right">
                <p>
                  <b>{{ user.email }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <span class="btn btn-secondary mt-4" @click="handleBackSteep"
        >Volver</span
      >
      <div v-show="canBuy && sacoin">
        <span v-show="isBuying" class="btn btn-success mt-4">Comprando...</span>
        <span
          v-show="!isBuying"
          class="btn btn-success mt-4"
          @click="handleNextSteep"
          >Confirmar compra</span
        >
      </div>
      <router-link to="/carrito" v-if="!canBuy">
        <span class="btn btn-treid mt-4">Ver carrito</span>
      </router-link>
    </div>
    <ModalNewBuy :visible="modalNewBuy.visible" />
    <ModalWrongBuy
      :visible="modalWrongBuy.visible"
      :message="modalWrongBuy.message"
    />
  </div>
</template>


<script>
import Configs from "../../configs/configs";
import Api from "../../tools/Api2";
import ModalNewBuy from "../modals/ModalNewBuy.vue";
import ModalWrongBuy from "../modals/ModalWrongBuy.vue";
import { mapMutations, mapState } from "vuex";
import { LC } from "../../tools/exchange";
//import calc from "@/tools/calc.js";

export default {
  name: "PaymentDetail",
  props: {},
  components: {
    ModalNewBuy,
    ModalWrongBuy,
  },
  data() {
    return {
      localCurrency: null,
      isOnlyServices: false,
      isBuying: false,
      /* --- */
      user: {},
      canBuy: true,
      sacoin: 0,
      financiamiento: 0,
      url: Configs.API.BASE,
      items: [],
      infoShipping: [],
      shippingType: 0,
      shippingPrice: 0,
      modalNewBuy: {
        visible: false,
      },
      modalWrongBuy: {
        visible: false,
        message: "",
      },
    };
  },
  computed: {
    ...mapState(["auth" /*, "changes"*/]),
    shippingPriceSC(){
      if(this.shippingType === 1){
        return this.shippingPrice;
      }
      return this.productSCPrice(this.shippingPrice, this.$parent.cartItems[0].currency)
    },
    discount() {
      if (!this.localCurrency) return 0;

      const reducer = (acc, item) => {
        let productPrice = this.localCurrency.localToSC({
          price: item.price,
          currency: item.currency,
        });
        return acc + productPrice * item.amountInCart * (item.discount / 100);
      };
      return this.$parent.cartItems.reduce(reducer, 0).toFixed(2);
    },
  },
  methods: {
    ...mapMutations(["clearItemCart"]),
    productSCPrice(price, currency) {
      if (!this.localCurrency) return 0;

      return this.localCurrency.localToSC({ price, currency });
    },
    handleBackSteep() {
      this.$parent.backSteep(this.$parent.inputs.shipping.ciudad.value ? 1 : 2);
    },
    handleNextSteep() {
      this.isBuying = true;
      Api("buy")
        .post({
          products: this.$parent.cartItems.map((e) => {
            if (e.kind == "product") {
              let options = e.options.map((option) => {
                return { name: option.form.name, value: option.value };
              });
              return {
                _id: e._id,
                amountInCart: e.amountInCart,
                kind: e.kind,
                options,
              };
            } else {
              return { _id: e._id, amountInCart: e.amountInCart, kind: e.kind };
            }
          }),
          shippingInfo: this.$parent.inputs.shipping,
        })
        .then((res) => {
          this.isBuying = false;
          if (!res.error) {
            this.modalNewBuy.visible = true;
            this.clearItemCart();
          } else {
            this.modalWrongBuy.message = res.message;
            this.modalWrongBuy.visible = true;
          }
        })
        .catch((err) => {
          this.isBuying = false;
          this.modalWrongBuy.message = err;
          this.modalWrongBuy.visible = true;
        });
    },
  },
  created: function () {
    LC.new().then((localCurrency) => (this.localCurrency = localCurrency));

    // Seteamos el tipo de envio

    // Buscamos el metodo del primer producto
    let metodo = null;
    let price = 0;
    let i = 0;
    while (i < this.$parent.cartItems.length && !metodo) {
      if (
        this.$parent.cartItems[i].kind == "product" &&
        this.$parent.cartItems[i].shippingPrice > price
      ) {
        metodo = this.$parent.cartItems[i];
        price = this.$parent.cartItems[i].shippingPrice;
      } else if(this.$parent.cartItems[i].kind == "product" && this.$parent.cartItems[i].shippingType == 1){
        metodo = this.$parent.cartItems[i];
      }
      i++;
    }

    if (!metodo) {
      this.isOnlyServices = true;
    } else {
      this.shippingType = metodo.shippingType;
      this.shippingPrice =
        metodo.shippingType == 1
          ? this.$parent.inputs.shipping.pais.value == "MEX" &&
            this.$parent.inputs.shipping.estado.value == "CIUDAD DE MEXICO"
            ? 12
            : 15
          : metodo.shippingPrice;
      this.infoShipping = Object.keys(this.$parent.inputs.shipping).map((x) => {
        return { name: x, value: this.$parent.inputs.shipping[x].value };
      });
    }

    Api("sistem-apple")
      .get("get-saldo")
      .then((res) => {
        // ver esto
        let resto = +this.$parent.totalCart + this.shippingPriceSC;

        const { maxFinanciacion, saldo } = res;

        if (maxFinanciacion + saldo >= resto) {
          this.sacoin = saldo > resto ? resto : saldo;
          this.financiamiento = resto - this.sacoin;
        } else {
          this.canBuy = false;
          this.sacoin = saldo;
          this.financiamiento = maxFinanciacion;
        }
      });

    Api("user")
      .get(this.auth.id)
      .then((res) => {
        this.user = res.user;
      });
  },
};
</script>